(function($){
            
    // console.log(userIPInfo.country_code);
    if (typeof(Storage) !== 'undefined') {
        

        var data = sessionStorage.getItem('redirect');
        
        if(data == null){
            
            if(userIPInfo.country_code == 'GB'){
                location.href = "https://thechillwayuk.com/";
            }

            sessionStorage.setItem('redirect', 'chillus');
        }
    } else {
        //alert('Trình duyệt của bạn đã quá cũ. Hãy nâng cấp trình duyệt ngay!');
    }

    // $(window).on("resize", function () {
    //     resize_product_feature();
    // });

    $(document).ready(function () {
        $('#loyaltyLauncher img').attr('src', 'https://cdn.shopify.com/s/files/1/0536/9115/4590/files/ic-rewards_185x@2x.jpg');
      
      	$("body").on("click", '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function () {
            if ($("#agree").is(":checked")) {
                $(".Cart__EnableCheckbox__Error").hide();
                $(this).submit();
            } else {
                $(".Cart__EnableCheckbox__Error").show();
                if (window.theme.pageType !== 'cart'){
                    document.querySelector('.Cart__EnableCheckbox__Error').scrollIntoView({behavior: "smooth"});
                }
                return false;
            }
        }); 

        $("body").on("click", '#sidebar-cart #agree', function(){
            localStorage.setItem("checked", "true");
        })            
    });

     $(window).on('load', function () {
        $('#loyaltyLauncher img').attr('src', 'https://cdn.shopify.com/s/files/1/0536/9115/4590/files/ic-rewards_185x@2x.jpg');
     });

    function resize_product_feature(){
        var width_list = $('.list-product-ft').width();
        var width_col = width_list/3 - 25;
        $('.section-feature-product .list-product-ft .col-slum-4 .ProductItem').css('width', width_col);
    }

})(jQuery)
document.addEventListener('theme:cart:updated', function(event) {
    console.log("cart Updated")
    $.getJSON("/cart.js", function(response) {
      const freeProduct = response.items.find(item => item.properties._club_member )
      const subscriptionProducts = response.items.filter(item => item.properties.shipping_interval_frequency)
      if (freeProduct && subscriptionProducts.length === 0) {
          const element = document.querySelector(`[data-line-key="${freeProduct.key}"]`)
          element.click()
      }
    })
  });
  
  function goToRechargeCheckout(){
      var paramCart = '&cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)')||0)[2];
  
      var paramLinker;
      try {
        paramLinker = `&${ga.getAll()[0].get('linkerParam')}`;
      } catch (err) {
        paramLinker = '';
      }
  
      if(document.getElementById('agree').checked){
            window.location.href = `https://checkout.rechargeapps.com/r/checkout?myshopify_domain=${Shopify.shop}${paramCart}${paramLinker}`
      }
  }


function moveItemToCartDrawer(el, event) {
    event.preventDefault();

    var variant_id = $(el).attr("data-id");
    data = {
        "id": variant_id,
        "quantity": 1
    }
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() { 
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true  //this code is for prestige theme, to refresh the cart
            }));
        }   
    }); 
}

if(window.location.href == 'https://chill.com/collections/all' || window.location.href == 'https://chill.com/collections'){
    function pageRedirect() {
        window.location.replace("https://chill.com/collections/shop");
    }      
    setTimeout("pageRedirect()", 200);
}



var item = document.querySelector('.HorizontalList__Item');
var arrow = document.querySelector('.arrow-icon');
item.addEventListener("click",function(index, e){
    
    this.querySelector('.arrow-icon').classList.toggle('upward');
    var x = document.querySelector('.DropdownMenu').getAttribute("aria-hidden"); 
    if (x == "true"){
        x = "false";
        arrow.classList.add('upward');
       
    } else {
        x = "true";
        arrow.classList.remove('upward');
    }
    this.querySelector('.DropdownMenu').setAttribute("aria-hidden", x);    
  });

  var target = document.querySelector('.site-switch');
  var x = target.querySelector('.HorizontalList__Item');
  var xx = x.children[0].querySelector('.arrow-icon');
  x.addEventListener("mouseover",function(index, e){
  if (x.classList.contains('is-expanded')) {
    xx.classList.remove('upward');
  }else{
    xx.classList.add('upward');
  }
});